
import React from "react";
import { Checkbox } from "@/components/ui/checkbox";

// Attestation Section
interface AttestationSectionProps {
  attestation: boolean;
  setAttestation: (checked: boolean) => void;
}

export const AttestationSection = ({ attestation, setAttestation }: AttestationSectionProps) => {
  return (
    <div className="flex items-start space-x-3 pt-4">
      <Checkbox 
        id="attestation"
        checked={attestation}
        onCheckedChange={(checked) => setAttestation(checked === true)}
      />
      <label 
        htmlFor="attestation"
        className="text-sm leading-tight text-black"
      >
        I declare all my cars are properly inspected and insured per local state laws
      </label>
    </div>
  );
};

export default AttestationSection;
